import { MonetaryAmount } from "../../../currency/currencyTypes"
import { PaymentMethodType } from "../../../payments/paymentTypes"

export enum CardType {
    WALLET = "WALLET",
    COMPANY_CREDIT = "COMPANY_CREDIT",
    TICKETS = "TICKETS",
    TICKETS_UNLIMITED = "TICKETS_UNLIMITED",
    TOP_UP = "TOP_UP",
    PAYROLL_DEDUCTION = "PAYROLL_DEDUCTION",
}

export type PaymentCardDetails = Readonly<{
    id: number
    name: string
    cardType: CardType
    cardNumber: string
    isActive: true
    validated?: string
    expiry?: string
    paymentMethod?: PaymentMethodType
}>

export type MerchantIdCardsUser = Readonly<{
    displayName: string
    employeeId: string
    email: string
    mobile?: string
    phone?: string
    userGroup: {
        id: number
        name: string
    }
    company: Company
    account: {
        number: string
        balance: MonetaryAmount
    }
}>

export type MerchantIdCards = Readonly<{
    paymentCard: PaymentCardDetails
    user: MerchantIdCardsUser
}>

type Company = Readonly<{
    id: string
    name: string
}>
